/**
 * UI Layout Constants
 *
 * レイアウト関連の定数を一元管理します。
 * これにより、複数のコンポーネント間で値の一貫性を保つことができます。
 */

/**
 * GlobalNavigationの高さ（px）
 * 使用箇所:
 * - GlobalNavigation.tsx (height)
 * - PageLayoutFrame.tsx (top position)
 * - SideNavigation.tsx (top position, height calculation)
 */
export const GLOBAL_NAVIGATION_HEIGHT = 48;

/**
 * PageLayoutFrameの高さ（px）
 * 使用箇所:
 * - PageLayoutFrame.tsx (min-height)
 */
export const PAGE_LAYOUT_FRAME_HEIGHT = 48;

/**
 * トップバナーの高さ（px）
 * 使用箇所:
 * - MainPageLayout.tsx (topBanner表示時のオフセット計算)
 */
export const TOP_BANNER_HEIGHT = 48;

/**
 * SideNavigationの幅（px）
 * 使用箇所:
 * - SideNavigation.tsx (width)
 * - PageLayoutFrame.tsx (left position offset)
 */
export const SIDE_NAVIGATION_WIDTH_CLOSED = 52;
export const SIDE_NAVIGATION_WIDTH_OPEN = 240;
export const LEFT_SIDE_NAVIGATION_WIDTH_OPEN = 320;
export const SECONDARY_NAVIGATION_WIDTH = 200;
export const MIN_MAIN_CONTENT_WIDTH = 720;
export const MAX_LEFT_SIDE_NAVIGATION_WIDTH_OPEN =
  SIDE_NAVIGATION_WIDTH_OPEN + MIN_MAIN_CONTENT_WIDTH;

/**
 * z-indexの階層定義
 *
 * レイヤー構造（下から上へ）:
 * 1. Base: 通常のコンテンツ (z-index: 0-9)
 * 2. SideNavigation: サイドナビゲーション (z-index: 20)
 * 3. TableStickyHeader: テーブルstickyヘッダー (z-index: 25)
 * 4. SidePanel: サイドパネル (z-index: 30)
 * 5. HeaderPopover: ヘッダー内Popover (z-index: 35)
 * 6. Fixed UI: PageLayoutFrame (z-index: 40)
 * 6.5. StickyNote: デバッグ用付箋 (z-index: 45)
 * 7. GlobalNavigation: グローバルナビゲーション (z-index: 50)
 * 8. Tooltip/Popover: Radix UIコンポーネント (z-index: 50+, 自動管理)
 */

/**
 * テーブルstickyヘッダーのz-index
 * 使用箇所:
 * - StickyTableWrapper.tsx
 *
 * 注: SideNavigation(20)より上、SidePanel(30)より下
 */
export const TABLE_STICKY_HEADER_Z_INDEX = 25;

/**
 * ヘッダー内Popoverのz-index
 * 使用箇所:
 * - FilterPopover.tsx（絞り込みPopover共通コンポーネント）
 * - DisplaySettingsPopover.tsx（表示設定Popover）
 *
 * 注: PageLayoutFrame(40)より下、SidePanel(30)より上。
 * ヘッダー内のツールバーから開くPopoverに使用する。
 * スクロール時にPageLayoutFrameの下に潜る。
 */
export const HEADER_POPOVER_Z_INDEX = 35;

/**
 * GlobalNavigationのz-index
 * 使用箇所:
 * - GlobalNavigation.tsx
 */
export const GLOBAL_NAVIGATION_Z_INDEX = 50;

/**
 * PageLayoutFrameのz-index
 * 使用箇所:
 * - PageLayoutFrame.tsx
 *
 * 注: Tooltip等のRadix UIコンポーネント(z-index: 50+)より下にする必要がある
 */
export const PAGE_LAYOUT_FRAME_Z_INDEX = 40;

/**
 * SidePanelのz-index
 * 使用箇所:
 * - SidePanel.tsx
 */
export const SIDE_PANEL_Z_INDEX = 30;

/**
 * SideNavigationのz-index
 * 使用箇所:
 * - SideNavigation.tsx
 *
 * 注: PageLayoutFrameより下、通常コンテンツより上
 */
export const SIDE_NAVIGATION_Z_INDEX = 20;

/**
 * StickyNoteのz-index（デバッグ用付箋）
 * 使用箇所:
 * - StickyNoteItem.tsx
 *
 * 注: PageLayoutFrame(40)より上、GlobalNavigation(50)より下
 */
export const STICKY_NOTE_Z_INDEX = 45;
